<template>
<div class="about">
  <v-layout row>
    <v-flex md12>
      <v-card :disabled="btnLoad > 0" flat class="mb-2">
        <v-card-title>
          Retatório de dados
        </v-card-title>
        <v-layout row class="mx-2">
          <v-flex md4 class="pr-1">
            <empresas-select v-on:empresa-select="getEmpresa"></empresas-select>
          </v-flex>
          <v-flex md4 class="pr-1">
            <unidades-select :mEmpresa="empresa" v-on:multi-unidades="getMultiUnidades"></unidades-select>
          </v-flex>
          <!-- <v-autocomplete standard v-model="unidade" label="Unidades" :items="unidades" return-object item-text="nome"></v-autocomplete> -->
          <!-- <v-autocomplete multiple v-model="multiConvenios" label="Convenios" :items="convenios" item-text="nome" item-value="id"></v-autocomplete> -->
          <v-flex md4>
            <dateForm :data="filtro" @dataInicio="save" @dataFim="saveEnd"></dateForm>
          </v-flex>
        </v-layout>
        <v-card-actions>
          <v-radio-group row v-model="radios" :mandatory="false">
            <v-radio label="Listar todas" :value="2"></v-radio>
            <v-radio label="Publico" :value="0"></v-radio>
            <v-radio label="Privado" :value="1"></v-radio>
          </v-radio-group>
          <v-spacer></v-spacer>`Ω`
          <v-btn color="warning" @click.stop="limparDados()" text>
            Ambos
          </v-btn>
          <v-btn :loading="btnLoad > 0" :disabled="dateEnd == null" class="ma-2" color="primary" @click="carregarDados">
            <v-icon left>search</v-icon> Buscar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</div>
</template>

<script>
import service from './../../services/userservice'
import dateForm from './../dateForm'
import empresasSelect from './components/empresas'
import unidadesSelect from './components/unidades'
import {
  EventBus
} from './../../main'

export default {
  name: 'filtro',
  components: {
    dateForm,
    empresasSelect,
    unidadesSelect
  },
  data () {
    return {
      date: null,
      radios: 2,
      empresas: [],
      empresa: {
        id: 0
      },
      minDate: '',
      btnLoad: 0,
      params: {},
      dateEnd: null,
      filtro: null,
      unidades: [],
      multiUnidades: [],
      isUnidade: false,
      erroDate: '',
      unidadesProcessamento: [],
      unidadeProcessamento: {
        idCidade: 0,
        idUnidadeNegocio: 0,
        idUnidadeProcessamento: 0
      },
      unidade: null,
      load: false
    }
  },
  watch: {
    unidadeProcessamento (val) {
      this.isUnidade = false
    },
    unidade (val) {
      this.isUnidade = false
    }
  },
  methods: {
    getEmpresa (data) {
      this.empresa = data
      // this.listarUnidades()
    },
    getMultiUnidades (data) {
      this.multiUnidades = data
    },
    carregarDados () {
      this.isMsg = false
      this.btnLoad = 0
      this.erroDate = null
      if (this.unidade == null) {
        this.unidade = {
          id: 0,
          idUnidadeProcessamento: 0
        }
      }
      var dInicio = new Date(this.date)
      var dFim = new Date(this.dateEnd)
      if (dInicio <= dFim) {
        // EventBus.$emit('loadStop', 1)
        this.$emit('carregar-dados', {
          tipoConvenio: this.radios,
          dataInicio: dInicio,
          dataFim: dFim,
          idCidadeProcessamento: this.unidadeProcessamento.idCidade,
          idUnidadeProcessamento: this.unidadeProcessamento.idUnidadeProcessamento,
          idsUnidades: this.multiUnidades,
          idEmpesa: this.empresa.id,
          idUnidadeNegocio: this.unidade.id
        })
      } else {
        this.erroDate = 'Erro na escolha da data.'
      }
    },
    limparDados () {
      EventBus.$emit('limpar-dados')
      this.unidade = null
      this.empresa = null
      this.multiUnidades = []
      this.multiConvenios = null
      this.unidades = null
      this.unidadeProcessamento = {
        idCidade: 0,
        idUnidadeNegocio: 0,
        idUnidadeProcessamento: 0
      }
      // this.selecionarUnidades()
      this.listarUnidadesProcessamento()
      this.allUnidades()
    },
    save (date) {
      this.date = date
    },
    saveEnd (date) {
      this.dateEnd = date
    },
    listarUnidadesProcessamento () {
      this.load = true
      service.listarUnidadesProcessamento().then(r => {
        this.unidadesProcessamento = r.data
      }).finally(() => {
        this.load = false
      })
    },
    listarEmpresas () {
      this.load = true
      service.listarEmpresas().then(r => {
        this.empresas = r.data
      }).finally(() => {
        this.load = false
      })
    },
    allUnidades () {
      this.load = true
      service.buscarUnidades().then(r => {
        if (r.status === 200) {
          this.mUnidades = r.data
          this.unidades = this.mUnidades
          this.isUnidade = true
        }
      }).finally(r => {
        this.load = false
      })
    }
    // listarConvenios () {
    //   this.load = true
    //   let idEmpresa = 0
    //   if (this.empresa != null) {
    //     idEmpresa = this.empresa.id
    //   }
    //   if (this.unidade)
    // },
    /* listarUnidades () {
      this.load = true
      let idUnidadeNegocio = 0
      let idEmpresa = 0
      if (this.empresa != null) {
        idEmpresa = this.empresa.id
        idUnidadeNegocio = 0
      } else if (this.unidadeProcessamento != null) {
        idUnidadeNegocio = this.unidadeProcessamento.id
        idEmpresa = this.unidadeProcessamento.idEmpresa
      }
      service.listarUnidades({
        idUnidadeNegocio: idUnidadeNegocio,
        idEmpresa: idEmpresa
      }).then(r => {
        if (r.status === 200) {
          this.unidades = r.data
        } else if (r.status === 203) {}
      }).finally(() => {
        this.load = false
      })
    }, */
    // computerBtnLoad (i) {
    //   this.btnLoad = this.btnLoad - i
    //   if (this.btnLoad === 0) {
    //     EventBus.$emit('loadStop', false)
    //   }
    // },
    // computerBtnLoadStart (i) {
    //   this.btnLoad = this.btnLoad + 1
    // }
  },
  mounted () {
    // this.criarGrafico(this.graficos)
    // this.listarEmpresas()
    // EventBus.$on('btnLoadStart', this.computerBtnLoadStart)
    // EventBus.$on('btnLoad', this.computerBtnLoad)
    EventBus.$on('filtro', this.carregarFiltro)
  }
}
</script>
